import React from "react";
import { Routes } from "../features";
// import { ThemeProvider } from "@material-ui/styles";
import IconLogo from "../features/common/layout/Header";
import Container from "../features/common/layout/Container";
// import { createMuiTheme } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import Footer from '../features/common/layout/Footer';

// const theme = createMuiTheme({});

export const Apps = () => {
  return (
    <>
      <IconLogo />

      <Container>
        <Routes />
      </Container>

      <Footer/>
    </>
  );
};
export const App = withRouter(Apps);
